import { render, staticRenderFns } from "./suspicionDetails.vue?vue&type=template&id=4f64eb28"
import script from "./suspicionDetails.vue?vue&type=script&lang=js"
export * from "./suspicionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports